import React from 'react';
import BzDropdownButton, { DropdownButtonItem } from '../buttons/BzDropdownButton';
import { Matcher } from '../../types/rest/dslTypes';
import { allMatcherOperators } from '../../views/AssetCatalog/Transactions/TransactionEditor/TransactionEditor';

interface MatcherOperatorDropdownProps {
  isReadOnly: boolean;
  selected: DropdownButtonItem;
  onSelect: (item: DropdownButtonItem) => void;
  id: string;
  isShortTitle: boolean;
  /** List of supported matchers */
  operators: Matcher[];
}

const MatcherOperatorDropdown = (props: MatcherOperatorDropdownProps) => {
  const getItems = () => {
    return props.operators.map(
      item =>
        ({
          key: item,
          title: allMatcherOperators[item],
        } as DropdownButtonItem),
    );
  };

  return (
    <BzDropdownButton
      disabled={props.isReadOnly}
      dropdownItems={getItems()}
      selectedItem={props.selected}
      onSelectedItem={props.onSelect}
      variant="secondary"
      id={'op-' + props.id}
      shortTitle={props.isShortTitle}
    />
  );
};

export default MatcherOperatorDropdown;
